<template lang="pug">
  #app.page
    Header

    transition(name="fade"  mode="out-in")
        router-view

    //popupCallPhone
    //popupMessage
    //.page__preloader
      //Preloader
</template>

<script>
  import Header from '@/components/common/header/Header';
  //import popupCallPhone from '@/components/common/popups/popupCallPhone/popupCallPhone.vue';
  //import popupMessage from '@/components/common/popups/popupMessage/popupMessage.vue';
  //import Preloader from '@/components/common/preloader/Preloader.vue';

  export default {
    components: {
      Header,
      //popupCallPhone,
      //popupMessage,
      // Preloader
    }
  }
</script>

<style>
    .fancybox-bg {
        background: rgba(66, 90, 113, 1) !important;
        opacity: 0.8 !important;
    }
    .fancybox-navigation {
        display: none;
    }

    .fancybox-close-small {
        display: none;
    }

    .ps__rail-y {
        width: 3px;
    }

    .ps .ps__thumb-y {
        width: 100%;
        border-radius: 1px;
    }

    .fade-enter {
        opacity: 0;
    }
    .fade-enter-active {
        transition: opacity .2s ease-in-out .1s;
    }
    .fade-enter-to {
        opacity: 1;
    }

    .fade-leave {
        opacity: 1;
    }
    .fade-leave-active {
        transition: opacity .2s ease-in-out;
    }
    .fade-leave-to {
        opacity: 0;
    }
</style>
